export default __webpack_public_path__ + "static/media/DSC_7854.bacd22a2.jpg";